/**
 * author jack
 * created 18-12-11
 * ex)
 *
import LoadScript from 'common/modules/loadScript'

<aside className="mediumSide" id="asdieMedium"></aside>

window.cate_id = itemInfo.result.item.cate_id
LoadScript("//cdnjs.happyshopping.kr/_v5/react/aside_medium/static/js/main.js")
 */
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

ReactDOM.render(
    <App />,
    document.getElementById('asideMedium')
);



// WEBPACK FOOTER //
// ./src/aside_medium/index.js